export default "__VITE_ASSET__CQjBRkty__"